export const clientTypes = {
  BROWSER: 'browser',
  MOBILE_BROWSER: 'mobile-browser',
  IOS: 'ios',
  UNKNOWN: 'unknown',
}
